"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.formatNumber = formatNumber;
exports.formatUSD = formatUSD;
exports.secondsToMinutes = void 0;

var _isString = _interopRequireDefault(require("lodash/isString"));

function formatUSD(amount) {
  if (!amount) {
    return '$0.00';
  }

  return parseFloat((0, _isString["default"])(amount) ? amount.replace(/,/g, '') : amount).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  });
}

function formatNumber(value) {
  if (value === void 0) {
    value = 0;
  }

  var number = (0, _isString["default"])(value) ? parseFloat(value.replace(/,/g, '')) : value;
  return number.toLocaleString('en-US');
}

var secondsToMinutes = function secondsToMinutes(seconds) {
  return Math.floor(seconds / 60) + ":" + ("0" + Math.floor(seconds % 60)).slice(-2);
};

exports.secondsToMinutes = secondsToMinutes;